import { Skeleton } from '@heroui/react';

export function NftCardSkeleton({ count = 1 }: { count?: number }) {
  return Array.from(Array(count).keys()).map((i) => (
    <div className="flex flex-col gap-1" key={i}>
      <Skeleton className="bg-default-300 aspect-square w-[165px] rounded-lg" />
      <Skeleton className="bg-default-300 h-4 w-full rounded-lg" />
      <Skeleton className="bg-default-300 h-3 w-1/2 rounded-lg" />
    </div>
  ));
}
